export const model = {
  number: '',
  begin_date: '',
  supplier_id: null,
  status_id: null,
  sum: null,
  description: ''
};